import React, {useEffect, useState} from 'react';
import {QualitySubMenuItems} from './QualitySubmenuList';
import {TransformValues} from '../../utils/helper';
import {Quality} from '../../ui-components/Iconpack';
import {toast} from 'react-toastify';
import Tracker from '../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../lib/analytics/events';
import {TransformationType} from '../../screens/TransformationV2/Transformation';

interface QualitySubmenuProps {
    onTransformValuesChange: (values: {quality: string}) => void;
    transformationObject: TransformValues;
    addTransformation: (t: TransformationType) => void;
}

export default function QualitySubmenu({
    onTransformValuesChange,
    transformationObject,
    addTransformation,
}: QualitySubmenuProps) {
    const [selectedQuality, setSelectedQuality] = useState<string | null>(null);

    const handleQualityChange = (quality: string, qualityTitle: string) => {
        Tracker.trackEvent(EventNames.TRANSFORMATION_QUALITY_MODIFIED, {
            [EventProperty.Quality]: quality,
        });
        setSelectedQuality(quality);
        onTransformValuesChange({quality});
        addTransformation(TransformationType.QUALITY);
        toast.success(`Image quality changed to ${qualityTitle}`);
    };
    useEffect(() => {
        if (transformationObject.quality) {
            setSelectedQuality(transformationObject.quality);
        }
    }, []);

    return (
        <>
            <div className='flex items-center'>
                <div className='block cursor-pointer items-center justify-center rounded-[6px] border-[2px] border-[#4E5BA6] bg-[#717BBC] p-[12px] md:mx-[16px] md:hidden'>
                    <Quality color='#FFFFFF' />
                </div>
                <div className='flex flex-col pl-[6px] text-[14px] font-[700] text-[#FFFFFF] md:pl-0'>
                    <span>IMAGE QUALITY</span>
                </div>
            </div>
            <span className='flex flex-col gap-5 pt-6 text-[12px] font-[700] text-[#FFFFFF] md:pt-5'>
                Set image quality
            </span>
            <div className='mt-[18px]'>
                <ul className='flex flex-col justify-center gap-4 pt-4'>
                    {QualitySubMenuItems.map((item, index) => {
                        return (
                            <div
                                key={item.title}
                                className={'cursor-pointer'}
                                onClick={() => handleQualityChange(item.value, item.title)}>
                                <li
                                    key={item.title}
                                    className={`flex items-center justify-between rounded-[6px] border border-[#3E4784] bg-[#293056] py-[13px] pl-[10px] pr-[16px] ${selectedQuality === item.value ? 'bg-[#717BBC]' : ''}`}>
                                    <div className={'flex justify-between gap-2'}>
                                        <input
                                            type='radio'
                                            className='h-4 w-4'
                                            checked={selectedQuality === item.value}
                                        />
                                        <span className={`text-[12px] font-[700] text-[#FFFFFF]`}>{item.title}</span>
                                    </div>
                                    <span className={`text-[12px] font-[700] text-[#FFFFFF]`}>
                                        {item.displayPercent}
                                    </span>
                                </li>
                            </div>
                        );
                    })}
                </ul>
            </div>
            {/* Add this once the refactoring of editor done! */}
            {/*{*/}
            {/*    <div className={"mt-6 md:mt-20 p-3 rounded-xl bg-[#252B4C] text-[14px]"}>*/}
            {/*        <div className={"flex gap-1 items-center"}>*/}
            {/*            <ChangeAlertIcon/>*/}
            {/*            <span className={"text-white font-[600]"}>Change in image size</span>*/}
            {/*        </div>*/}
            {/*        <span className={"text-gray-300"}>*/}
            {/*            The image size has increased due to so & some other changes*/}
            {/*        </span>*/}
            {/*    </div>*/}
            {/*}*/}
        </>
    );
}
